import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { UI_MASKS } from '@/utils/uiMasks';

import {ILocationModel, ITaxRate} from '@/models/location.models';

@Component({
    selector: 'location-edit-form',
    templateUrl: './locationEditForm.template.html',
    host: {'class': 'location-edit-form-component'}
})

export class LocationEditFormComponent implements OnInit {
    @Input()
    model: ILocationModel;

    @Input()
    showAlert: boolean = false;

    @Input()
    permissionLock: boolean;

    @Output()
    onSave: EventEmitter<ILocationModel> = new EventEmitter<ILocationModel>();

    @Output()
    onGoToLocation: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    onCancel: EventEmitter<void> = new EventEmitter();

    defaultRates: Array<ITaxRate> = [
      { name: 'County', rate: 0.00 },
      { name: 'City', rate: 0.00 },
      { name: 'State', rate: 0.00 },
      { name: 'Mkecounty', rate: 0.00 },
      { name: 'Stadium', rate: 0.00 },
    ];

    constructor(public uiMasks: UI_MASKS) {}

    ngOnInit(): void {
      if (!this.model.useTaxRates || this.model.useTaxRates.length === 0) {
        this.model.useTaxRates = JSON.parse(JSON.stringify(this.defaultRates));
      }

      if (!this.model.taxRates || this.model.taxRates.length === 0) {
        this.model.taxRates = JSON.parse(JSON.stringify(this.defaultRates));
      }
    }

    saveLocation(): void {
        this.onSave.emit(this.model);
    }

    goToLocation(): void {
        this.onGoToLocation.emit(null);
    }

    getOrderedTaxRates(taxRates: Array<ITaxRate>): Array<ITaxRate> {
      if (!taxRates.length) return [];
      return [
        taxRates.find(rate => rate.name === 'County'),
        taxRates.find(rate => rate.name === 'Mkecounty'),
        taxRates.find(rate => rate.name === 'State'),
        taxRates.find(rate => rate.name === 'City'),
        taxRates.find(rate => rate.name === 'Stadium')
      ];
    }

    updateRate(e: any, rate: ITaxRate): void {
      rate.rate = e / 100;
    }

    cancel(): void {
        this.onCancel.emit(null);
    }
}
